import { reactive } from 'vue'
import { defineStore } from 'vue_features/shared/composables/store_helpers'
import { openModal, closeModal, canModalShow } from 'vue_features/shared/composables/use_global_modals'

export const useGatesSurveyStore = defineStore('gatesSurvey', () => {
  const state = reactive({
    surveys: [],
    completedSurveyIds: [],
  })

  function fullyAnswered(surveyId) {
    if (state.completedSurveyIds.includes(surveyId)) return true

    const survey = state.surveys.find((s) => s.id === surveyId)
    if (!survey) return false

    return survey.gatesSurveyQuestions.every(
      (question) => question.gatesSurveyQuestionResponses && question.gatesSurveyQuestionResponses.length > 0,
    )
  }

  function surveyForTypeFeatureRound(surveyType, feature, round) {
    return state.surveys.find((survey) => {
      return survey.surveyType == surveyType && survey.feature == feature && survey.round == round
    })
  }

  function canSurveyShow(surveyId) {
    return canModalShow(surveyKey(surveyId))
  }

  function closeSurvey(surveyId) {
    const key = surveyKey(surveyId)
    closeModal(key)
  }

  function markSurveyComplete(surveyId) {
    if (!state.completedSurveyIds.includes(surveyId)) {
      state.completedSurveyIds.push(surveyId)
    }
  }

  function showSurvey(surveyId) {
    if (fullyAnswered(surveyId)) return
    openModal(surveyKey(surveyId))
  }

  function showSurveyFor(type, feature, round) {
    const survey = surveyForTypeFeatureRound(type, feature, round)
    if (survey) {
      showSurvey(survey.id)
    }
  }

  function surveyKey(surveyId) {
    return `gates-survey-${surveyId}`
  }

  return {
    state,
    fullyAnswered,
    canSurveyShow,
    closeSurvey,
    markSurveyComplete,
    showSurvey,
    showSurveyFor,
    surveyForTypeFeatureRound,
    surveyKey,
  }
})
